import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { DeprecatedInput, deprecatedInputKey } from './input';
import { KeyCode } from '../../common/key-codes.enum';
import { getLegacyBaseDriverFromWrapper } from '../../common/base-driver';
export var createLegacyDeprecatedInputDriver = function (wrapper) {
    var baseDriver = getLegacyBaseDriverFromWrapper(wrapper, "." + deprecatedInputKey, DeprecatedInput.name);
    var inputField = baseDriver.find('.input-field');
    var inputElem = inputField.elem;
    return {
        getValue: function () { return inputElem.value; },
        enterValue: function (value) { return inputField.enterValue(value); },
        pressEnter: function () { return inputField.pressKey(KeyCode.ENTER); },
        isDisabled: function () { return inputElem.hasAttribute('disabled'); },
        isReadOnly: function () { return inputElem.hasAttribute('readonly'); },
        isValid: function () { return inputElem.classList.contains('invalid') ? false : true; },
        getValidationErrorMessage: function () { return baseDriver.find('.validation-error').getText(); },
        getPlaceholder: function () { return inputElem.getAttribute('placeholder') || ''; }
    };
};
export var createDeprecatedInput = function (props) {
    var elem = renderAndMountComponent(React.createElement(DeprecatedInput, __assign({}, props)));
    return createLegacyDeprecatedInputDriver(elem);
};
//# sourceMappingURL=input.legacy-driver.js.map